// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  playerId: __t.string().name("player_id"),
  ruleset: __t.string(),
  playerName: __t.string().name("player_name"),
  avatarName: __t.string().name("avatar_name"),
  avatarStatus: __t.string().name("avatar_status"),
  selectedStarterTerritoryId: __t.option(__t.string()).name("selected_starter_territory_id"),
  controlledTerritoryCount: __t.u32().name("controlled_territory_count"),
  replenishmentRate: __t.f64().name("replenishment_rate"),
  unlockedUnitsJson: __t.string().name("unlocked_units_json"),
  unlockedTechJson: __t.string().name("unlocked_tech_json"),
  culture: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  armyBannerId: __t.option(__t.string()).name("army_banner_id"),
  armyColor: __t.option(__t.string()).name("army_color"),
  armyMarkerTerritoryId: __t.option(__t.string()).name("army_marker_territory_id"),
  armyMarkerX: __t.option(__t.f64()).name("army_marker_x"),
  armyMarkerY: __t.option(__t.f64()).name("army_marker_y"),
});
